import { configureStore } from '@reduxjs/toolkit';
import { reducer as formReducer } from 'redux-form';

// Create a minimal Redux store just for redux-form compatibility
// react-admin v5 no longer uses Redux internally, but redux-form still requires it
const store = configureStore({
  reducer: {
    form: formReducer,
  },
  // Disable serializable check for redux-form compatibility
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
